import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';
import TimesheetCheckbox from '../../../TimesheetCheckbox';

const TimesheetsTableHead = ({ ids }: any): React.ReactElement => (
    <Table.Header
        // HACK inline styles
        style={{
            fontSize: 14
        }}
    >
        <Table.Row>
            <Table.HeaderCell className="checkbox">
                <TimesheetCheckbox rowId={ids} />
            </Table.HeaderCell>
            <TableHeadTableCell label="First Name" value="personFirstName" />
            <TableHeadTableCell label="Last Name" value="personLastName" />
            <TableHeadTableCell label="Group" value="groupName" />
            <TableHeadTableCell label="Task" value="workTypeName" />
            <TableHeadTableCell label="Area" value="entityName" />
            <TableHeadTableCell label="Comment" value="comment" />
            <TableHeadTableCell label="Total Time" value="sumTotalMinutes" />
            <TableHeadTableCell label="Approved" value="isApproved" />
            <TableHeadTableCell
                label="Approved By"
                value="approvedByUserName"
            />
            <TableHeadTableCell label="Submitted On" value="lastExportedAt" />
            <TableHeadTableCell
                label="Submission Ref."
                value="payrollExportId"
            />
            <Table.HeaderCell />
        </Table.Row>
    </Table.Header>
);

export default TimesheetsTableHead;
